// extracted by mini-css-extract-plugin
export default {"root":"root---IhnL1","label":"label---tpNPb","separator":"separator---PNggU","patronGroup":"patronGroup---tt039","expiredMessage":"expiredMessage---I_Swo"};